// Shared types/constants for the DefectsImageGallery module. Kept in a leaf
// file (no sibling imports) so the gallery, its helpers, the mutation hooks,
// and InteractiveImage can all reference them without circular imports.

export const DEFECT_IMAGE_TYPE = {
  new: 'new',
  cloned: 'cloned',
  prev: 'prev',
} as const;

export type DrawableCollection = {
  rectangles: number[][];
  arrows: number[][];
};

export type UpdateImageParams = {
  inspectionId: string;
  observationId: string;
  defectId: string;
  photoId: string;
};

export type UpdateImagePayload = {
  drawables: string;
};
